import IconButton from '@material-ui/core/IconButton';
import { CheckOutlined } from '@material-ui/icons';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Icon, Tag } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import defaultLanguageChallenge from '../../../../assets/img/default_language_challenge.svg';
import { getGCSUrl } from '../../../../services/Common';
import { pushLog2DV2LogServer } from '../../../../services/logging';
import useFlagsFromBackend, { GB_FLAGS } from '../../../services/launchDarkly';
import '../Tests.css';

const WorkExpNotCompletedLock = ({ use_role_based_mcq_uiux }) => {
  return (
    <div className="turing-ui-v2-lock-work-exp-wrapper">
      <Icon type="lock" theme="filled" />
      <span className="turing-ui-v2-lock-work-exp-info">{use_role_based_mcq_uiux ? 'Pass one core quiz to unlock' : 'Take Seniority Assessment to unlock'}</span>
    </div>
  );
};

const TestsSections = (props) => {
  const { mcqfilter, use_role_based_mcq_uiux } = useFlagsFromBackend([GB_FLAGS.mcqfilter, GB_FLAGS.use_role_based_mcq_uiux]);
  if (!props.show) return null;
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const forceUpdate = () => {
    setLastUpdate(new Date());
  };

  const filtersToBe = (() => ({
    all: { name: 'All', checked: true },
    recommended: { name: 'Skill-based', checked: false }
  }))();

  (props.tagsMCQFilter || []).forEach(tagMCQFilter => {
    filtersToBe[tagMCQFilter.tag_name.toLowerCase()] = { name: tagMCQFilter.tag_name, checked: false };
  });

  const [filters, setFilters] = useState({});

  if (Object.keys(filtersToBe).length !== Object.keys(filters).length) {
    setFilters(filtersToBe);
  }

  const onTagClick = (key) => {
    const _filters = Object.assign(filters);
    if (key === 'all') {
      Object.keys(_filters).forEach((key) => {
        _filters[key].checked = false;
      });
      _filters.all.checked = true;
    } else {
      _filters.all.checked = false;
      _filters[key].checked = !_filters[key].checked;
      if (Object.keys(_filters).map((key) => _filters[key].checked).filter((checked) => checked === true).length < 1) {
        _filters.all.checked = true;
      }
      if (_filters[key].checked) {
        pushLog2DV2LogServer.info('MCQ', 'MCQ_FILTER_TAG_CHECKED', {}, { tag: _filters[key].name }, null);
      }
    }
    setFilters(_filters);
    forceUpdate();
    typeof props.onMCQTagFilterChange === 'function' && props.onMCQTagFilterChange(Object.keys(_filters).map(key => _filters[key]).filter(filter => filter.checked === true));
  };
  return (
    <div className={
      props.workExpCompleted
        ? (!props.hideTopBorder ? 'turing-ui-v2-tests-section' : 'turing-ui-v2-tests-section hide-border')
        : (props.hideTopBorder ? 'turing-ui-v2-tests-section turing-ui-v2-work-exp-not-complete' : 'turing-ui-v2-tests-section turing-ui-v2-work-exp-not-complete hide-border') }>
      <input type="hidden" value={ lastUpdate } />
      <div className="turing-ui-v2-tests-section-header">
        <div>
          <h2>{props.label}{!props.workExpCompleted && <WorkExpNotCompletedLock use_role_based_mcq_uiux={use_role_based_mcq_uiux} />}</h2>
          <small style={{color: '#212121'}} dangerouslySetInnerHTML={{ __html: props.description }}></small>
        </div>
      </div>
      {props.search
        ? (
          <div style={{ marginBottom: '1rem' }}>
            <div className="turing-ui-v2-tests-section-filters">
              {
                mcqfilter
                  ? (
                    <div className="turing-ui-v2-tests-section-filters-skills InStackDemandSelector">
                      { Object.entries(filters).map(([key, filter], index) => {
                        return (
                          <Tag.CheckableTag
                            key={index}
                            checked={ filter.checked }
                            className="InStackDemandItem filter-skill"
                            onChange={(e) => { onTagClick(key); }}
                          >
                            <span className='skill-item'><CheckOutlined width={14} /> { filter.name }</span>
                          </Tag.CheckableTag>
                        );
                      }) }
                    </div>
                  )
                  : null
              }
              <div className="turing-ui-v2-tests-section-filters-search">
                { props.search }
              </div>
            </div>
          </div>
        )
        : null}
      <div className="turing-ui-v2-tests-section-content">{props.children}</div>
    </div>
  );
};

const ShowACCList = React.memo(({ dataSource, mode = 'showAll', length = 5, workExpCompleted, stackId = null, children, className = 'turing-ui-v2-mcq-tests-list', use_vetsmith_challenge_versioning }) => {
  const listACC = Array.isArray(dataSource) ? dataSource : [];
  const [state, setState] = useState({ start: 0 });
  state.set = (obj = {}) => {
    setState({ ...state, ...obj });
  };

  const handleNavClick = (direction) => e => {
    if (direction === 'left') {
      state.set({ start: Math.max(0, state.start - length) });
    } else {
      state.set({ start: Math.min(listACC.length - length, state.start + length) });
    }
  };

  if (mode === 'carrousel') {
    return (
      <div className="turing-ui-v2-mcq-tests-list">
        <div className="turing-ui-v2-mcq-tests-list-left-nav">
          <IconButton onClick={handleNavClick('left')} disabled={(state.start === 0) || !workExpCompleted}>
            <ArrowBackIcon/>
          </IconButton>
        </div>
        {listACC.slice(state.start, state.start + length).map(item => (
          use_vetsmith_challenge_versioning ?
          <ShowACCItemV2 stackId={stackId} key={item.id} item={item} workExpCompleted={workExpCompleted} />
          :
          <ShowACCItem stackId={stackId} key={item.challenge_id} item={item} workExpCompleted={workExpCompleted} />
        ))}
        <div className="turing-ui-v2-mcq-tests-list-right-nav">
          <IconButton onClick={handleNavClick('right')} disabled={(state.start + length >= listACC.length) || !workExpCompleted}>
            <ArrowForwardIcon/>
          </IconButton>
        </div>
      </div>
    );
  }

  if (typeof children === 'function') {
    return (
      <div className={className}>
        {listACC.map(children)}
      </div>
    );
  }

  return (
    <div className="turing-ui-v2-mcq-tests-list">
      {listACC.map(item => (
        use_vetsmith_challenge_versioning ?
        <ShowACCItemV2 stackId={stackId} workExpCompleted={workExpCompleted} key={item.id} item={item}/>
        :
        <ShowACCItem stackId={stackId} workExpCompleted={workExpCompleted} key={item.challenge_id} item={item}/>
      ))}
    </div>
  );
});

const ShowACCItem = React.memo(({ item, workExpCompleted, stackId }) => {

  const GCSIcon = `${getGCSUrl()}/icon/${item.icon}`;  

  const defaultIcon = '/images/no-image.png';
  const { MCQStatusOrTime, Action } = item;
  return (
    <div key={item.challenge_id} className={
      item.challenge_disabled ? 'turing-ui-v2-mcq-tests-item turing-ui-v2-disable-mcq-card' : 'turing-ui-v2-mcq-tests-item'
    }>
      {/* { item.recommended > 0 && <span className="star" style={{ position: 'absolute', top: '12px', right: '12px' }}><img src={importantIcon} className="importantIcon" /></span> } */}
      <div className="turing-ui-v2-mcq-tests-item-icon">
        <img className="mcq" src={item.icon ? GCSIcon : defaultIcon} alt={item.challenge_name} />
      </div>
      <div className="turing-ui-v2-mcq-tests-item-content">
        <span className="turing-ui-v2-mcq-tests-item-title">
          {item.challenge_name}
        </span>
        <span className="turing-ui-v2-mcq-tests-item-time">
          {MCQStatusOrTime && <MCQStatusOrTime/>}
        </span>
      </div>
      {Action && <Action stackId={stackId}/>}
    </div>
  );
});

/**
 * This component is used to show ACC items when the use_vetsmith_challenge_versioning flag is turned ON
 */
const ShowACCItemV2 = React.memo(({ item, workExpCompleted, stackId }) => {

  const defaultIcon = '/images/no-image.png';
  const { MCQStatusOrTime, Action } = item;
  return (
    <div key={item.id} className={
      item.challenge_disabled ? 'turing-ui-v2-mcq-tests-item turing-ui-v2-disable-mcq-card' : 'turing-ui-v2-mcq-tests-item'
    }>
      <div className="turing-ui-v2-mcq-tests-item-icon">
        <img className="mcq" src={item.icon ? item.icon : defaultIcon} alt={item.name} />
      </div>
      <div className="turing-ui-v2-mcq-tests-item-content">
        <span className="turing-ui-v2-mcq-tests-item-title">
          {item.name}
        </span>
        <span className="turing-ui-v2-mcq-tests-item-time">
          {MCQStatusOrTime && <MCQStatusOrTime/>}
        </span>
      </div>
      {Action && <Action stackId={stackId}/>}
    </div>
  );
});

const ShowMCQList = React.memo(({ dataSource, mode = 'showAll', length = 5, workExpCompleted, stackId = null, children, className = 'turing-ui-v2-mcq-tests-list', mcq_use_apiv1 }) => {
  const listMCQ = Array.isArray(dataSource) ? dataSource : [];
  const [state, setState] = useState({ start: 0 });
  state.set = (obj = {}) => {
    setState({ ...state, ...obj });
  };

  const handleNavClick = (direction) => e => {
    if (direction === 'left') {
      state.set({ start: Math.max(0, state.start - length) });
    } else {
      state.set({ start: Math.min(listMCQ.length - length, state.start + length) });
    }
  };

  if (mode === 'carrousel') {
    return (
      <div className="turing-ui-v2-mcq-tests-list">
        <div className="turing-ui-v2-mcq-tests-list-left-nav">
          <IconButton onClick={handleNavClick('left')} disabled={(state.start === 0) || !workExpCompleted}>
            <ArrowBackIcon/>
          </IconButton>
        </div>
        {listMCQ.slice(state.start, state.start + length).map(item => (
          <ShowMCQItem stackId={stackId} key={item.challenge_id} item={item} workExpCompleted={workExpCompleted} mcq_use_apiv1={mcq_use_apiv1} />
        ))}
        <div className="turing-ui-v2-mcq-tests-list-right-nav">
          <IconButton onClick={handleNavClick('right')} disabled={(state.start + length >= listMCQ.length) || !workExpCompleted}>
            <ArrowForwardIcon/>
          </IconButton>
        </div>
      </div>
    );
  }

  if (typeof children === 'function') {
    return (
      <div className={className}>
        {listMCQ.map(children)}
      </div>
    );
  }

  return (
    <div className="turing-ui-v2-mcq-tests-list">
      {listMCQ.map(item => (
        <ShowMCQItem stackId={stackId} workExpCompleted={workExpCompleted} key={item.challenge_id} item={item} mcq_use_apiv1={mcq_use_apiv1}/>
      ))}
    </div>
  );
});

const ShowMCQItem = React.memo(({ item, workExpCompleted, stackId, mcq_use_apiv1 }) => {
  let GCSIcon = undefined;

  /**
   * Post the rollout of the mcq_use_apiv1 to 100% users, remove the if condition check and assign item.icon directly to GCSIcon
   */
  if (mcq_use_apiv1) {
    GCSIcon = item.icon;
  } else {
    GCSIcon = `${getGCSUrl()}/icon/${item.icon}`;
  }
  
  const { MCQStatusOrTime, Action } = item;
  
  const defaultIcon = item.is_ai_challenge ? defaultLanguageChallenge : '/images/no-image.png';
  
  return (
    <div key={item.challenge_id} className={
      'turing-ui-v2-mcq-tests-item'
    }>
      {/* { item.recommended > 0 && <span className="star" style={{ position: 'absolute', top: '12px', right: '12px' }}><img src={importantIcon} className="importantIcon" /></span> } */}
      <div className="turing-ui-v2-mcq-tests-item-icon">
        <img className="mcq" src={item.icon ? GCSIcon : defaultIcon} alt={item.challenge_name} />
      </div>
      <div className="turing-ui-v2-mcq-tests-item-content">
        <span className="turing-ui-v2-mcq-tests-item-title">
          {item.challenge_name}
        </span>
        <span className="turing-ui-v2-mcq-tests-item-time">
          {MCQStatusOrTime && <MCQStatusOrTime/>}
        </span>
      </div>
      {Action && <Action stackId={stackId}/>}
    </div>
  );
});

/**
 * This component is used to show ACC List item container when use_vetsmith_challenge_versioning of multiple_lang_coding challenge step
 * This component is used to show MCQ List item container when use_vetsmith_mcq_challenge_versioning of mcq_required and mcq_recommended challenge step
 */
const ShowMCQListV2 = React.memo(({ dataSource, mode = 'showAll', length = 5, workExpCompleted, stackId = null, children, className = 'turing-ui-v2-mcq-tests-list' }) => {
  const listMCQ = Array.isArray(dataSource) ? dataSource : [];
  const [state, setState] = useState({ start: 0 });
  state.set = (obj = {}) => {
    setState({ ...state, ...obj });
  };

  const handleNavClick = (direction) => e => {
    if (direction === 'left') {
      state.set({ start: Math.max(0, state.start - length) });
    } else {
      state.set({ start: Math.min(listMCQ.length - length, state.start + length) });
    }
  };

  if (mode === 'carrousel') {
    return (
      <div className="turing-ui-v2-mcq-tests-list">
        <div className="turing-ui-v2-mcq-tests-list-left-nav">
          <IconButton onClick={handleNavClick('left')} disabled={(state.start === 0) || !workExpCompleted}>
            <ArrowBackIcon/>
          </IconButton>
        </div>
        {listMCQ.slice(state.start, state.start + length).map(item => (
          <ShowMCQItemV2 stackId={stackId} key={item.id} item={item} workExpCompleted={workExpCompleted}  />
        ))}
        <div className="turing-ui-v2-mcq-tests-list-right-nav">
          <IconButton onClick={handleNavClick('right')} disabled={(state.start + length >= listMCQ.length) || !workExpCompleted}>
            <ArrowForwardIcon/>
          </IconButton>
        </div>
      </div>
    );
  }

  if (typeof children === 'function') {
    return (
      <div className={className}>
        {listMCQ.map(children)}
      </div>
    );
  }

  return (
    <div className="turing-ui-v2-mcq-tests-list">
      {listMCQ.map(item => (
        <ShowMCQItemV2 stackId={stackId} workExpCompleted={workExpCompleted} key={item.id} item={item} />
      ))}
    </div>
  );
});

/**
 * This component is used to show ACC List items when use_vetsmith_challenge_versioning of multiple_lang_coding challenge step
 */
const ShowMCQItemV2 = React.memo(({ item, workExpCompleted, stackId}) => {
  const defaultIcon = item.is_ai_challenge ? defaultLanguageChallenge : '/images/no-image.png';
  const { MCQStatusOrTime, Action } = item;
  return (
    <div key={item.id} className={
      'turing-ui-v2-mcq-tests-item'
    }>
      <div className="turing-ui-v2-mcq-tests-item-icon">
        <img className="mcq" src={item.icon ? item.icon : defaultIcon} alt={item.name} />
      </div>
      <div className="turing-ui-v2-mcq-tests-item-content">
        <span className="turing-ui-v2-mcq-tests-item-title">
          {item.name}
        </span>
        <span className="turing-ui-v2-mcq-tests-item-time">
          {MCQStatusOrTime && <MCQStatusOrTime/>}
        </span>
      </div>
      {Action && <Action stackId={stackId}/>}
    </div>
  );
});

const ShowAptList = React.memo(({ dataSource, workExpCompleted, stackId = null }) => {
  const listApt = Array.isArray(dataSource.apt_challenges) ? dataSource.apt_challenges : [];
  const [state, setState] = useState({ start: 0 });
  state.set = (obj = {}) => {
    setState({ ...state, ...obj });
  };

  return (
    <div className="turing-ui-v2-mcq-tests-list">
      {listApt.map(item => (
        <ShowAptItem workExpCompleted={workExpCompleted} key={item.id} item={item} />
      ))}
    </div>
  );
});

const ShowAptItem = React.memo(({ item, workExpCompleted, stackId }) => {
  const defaultIcon = '/images/no-image.png';
  const { Action } = item;

  return (
    <div key={item.challenge_id} className={
      'turing-ui-v2-mcq-tests-item'
    }>
      <div className="turing-ui-v2-mcq-tests-item-icon">
        <img className="mcq" src={item.icon ? item.icon : defaultIcon} alt={item.challenge_name} />
      </div>
      <div className="turing-ui-v2-mcq-tests-item-content">
        <span className="turing-ui-v2-mcq-tests-item-title">
          {item.name}
        </span>
      </div>
      {Action && <Action stackId={stackId}/>}
    </div>
  );
});

TestsSections.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  show: PropTypes.any,
  children: PropTypes.any,
  workExpCompleted: PropTypes.bool,
  search: PropTypes.any,
  tagsMCQFilter: PropTypes.array,
  onMCQTagFilterChange: PropTypes.func,
  hideTopBorder: PropTypes
};

ShowMCQList.propTypes = {
  dataSource: PropTypes.array,
  mode: PropTypes.any,
  workExpCompleted: PropTypes.bool,
  length: PropTypes.number,
  children: PropTypes.any,
  stackId: PropTypes.number,
  className: PropTypes.string,
  mcq_use_apiv1: PropTypes.bool
};

ShowMCQListV2.propTypes = {
  dataSource: PropTypes.array,
  mode: PropTypes.any,
  workExpCompleted: PropTypes.bool,
  length: PropTypes.number,
  children: PropTypes.any,
  stackId: PropTypes.number,
  className: PropTypes.string,
};

ShowACCList.propTypes = {
  dataSource: PropTypes.array,
  mode: PropTypes.any,
  workExpCompleted: PropTypes.bool,
  length: PropTypes.number,
  children: PropTypes.any,
  stackId: PropTypes.number,
  className: PropTypes.string,
};

ShowACCItem.propTypes = {
  item: PropTypes.object,
  workExpCompleted: PropTypes.bool,
  stackId: PropTypes.number,
};

ShowMCQItem.propTypes = {
  item: PropTypes.object,
  workExpCompleted: PropTypes.bool,
  stackId: PropTypes.number,
  mcq_use_apiv1: PropTypes.bool
};

export { ShowACCItem, ShowACCList, ShowAptList, ShowMCQItem, ShowMCQList, ShowMCQListV2, TestsSections, WorkExpNotCompletedLock };

